import React, { useContext } from 'react';
import CreateASpoolContext from '../../../../context/createASpool/createASpoolContext';
import { RiskModelType } from '../../../../context/createASpool/createASpoolType';
import modalContext from '../../../../context/modal/modalContext';
import Button from '../../../../components/Button';
import SpoolsByRiskModel from './SpoolsByRiskModel/index';
import appContext from '../../../../context/app/appContext';

type Props = {
    riskModel: RiskModelType;
};

const RiskModelAccordionContent: React.FC<Props> = ({ riskModel }) => {
    const { selectedRiskModel, setSelectedRiskModel, next } =
        useContext(CreateASpoolContext);

    const { setCurrentViewingModel, chainRiskModels } = useContext(appContext);

    const { openModal } = useContext(modalContext);

    const hasContent = Object.keys(chainRiskModels).includes(riskModel.address);

    const handleSelect = () => {
        if (selectedRiskModel === riskModel.address) {
            next();
            return;
        }

        setSelectedRiskModel(riskModel.address);
    };

    const handleFullDetailsClick = () => {
        if (!hasContent) return;
        setCurrentViewingModel(riskModel.address);
        openModal('riskModelDetails');
    };

    return (
        <>
            <div className='title'>Summary</div>
            {hasContent ? (
                <div
                    className='content'
                    dangerouslySetInnerHTML={{
                        __html: chainRiskModels[riskModel.address].summary,
                    }}
                />
            ) : (
                <div className='content fallback'>
                    Summary for{' '}
                    <i>{chainRiskModels[riskModel.address]?.name ?? 'Risk Model'}</i> is
                    unavailable.
                </div>
            )}

            <hr />
            <div className='buttons-container'>
                <Button
                    variant='secondary'
                    onClick={handleFullDetailsClick}
                    disabled={!hasContent}
                >
                    Full details
                </Button>
                <Button onClick={handleSelect}>Select</Button>
            </div>
            <SpoolsByRiskModel riskModel={riskModel} />
        </>
    );
};

export default RiskModelAccordionContent;
